import store from '@polleverywhere/redux'
import { slice as responseHistorySlice } from '@polleverywhere/redux/slices/participant_response_history'
import { slice as registerFlowSlice } from './redux/registrationFlow'
import { slice as participantRegistrationsSlice } from './redux/participantRegistrations'
import { slice as activePresenterSlice } from './redux/activePresenter'
import { recentPresentations } from './util/recentPresentations'
import activitySync from './util/ActivitySync'
import { fetchActivity } from './util/fetchActivity'

export const PAGE_STATES = {
  live_response: async function loadLiveResponsePageState ({ username }) {
    recentPresentations.add(username)

    await store.dispatch(activePresenterSlice.loadPresenter(username))

    return {}
  },
  static_response: async function loadStaticResponsePageState ({ type, participantKey }) {
    const model = await fetchActivity(type, participantKey)
    const username = model.get('presenter_login') || model.get('owner_login')

    await store.dispatch(activePresenterSlice.loadPresenter(username))
    await activitySync.setCurrent(model)

    return {}
  },
  register: async function loadRegisterFlowPageState ({ username }) {
    await store.dispatch(activePresenterSlice.loadPresenter(username))
    store.addReducers({ [registerFlowSlice.name]: registerFlowSlice.reducer })
    store.dispatch(registerFlowSlice.reset())

    return {}
  },
  registrations: async function loadRegistrationsState ({ id }) {
    store.addReducers({ [participantRegistrationsSlice.name]: participantRegistrationsSlice.reducer })
    store.dispatch(participantRegistrationsSlice.reset())
    store.dispatch(participantRegistrationsSlice.fetch())
    if (id) {
      store.dispatch(participantRegistrationsSlice.focusRegistration(parseInt(id, 10)))
    }

    return {}
  },
  response_history: function ({ presenter, detail, page }) {
    store.addReducers({ [responseHistorySlice.name]: responseHistorySlice.reducer })

    if (detail) {
      store.dispatch(responseHistorySlice.focusResponse(detail))
    } else if (presenter) {
      store.dispatch(responseHistorySlice.filterPresenter(presenter))
    } else {
      store.dispatch(responseHistorySlice.fetchResponses(page || 1))
    }

    return {}
  }
}
